import { useState, useCallback } from 'react';
import type { Order, OrdersResponse } from '../types/orders';

export function useOrders(initialOrders: OrdersResponse) {
  const [orders, setOrders] = useState<OrdersResponse>(initialOrders);
  const [loading, setLoading] = useState(false);

  const updateOrderStatus = useCallback((orderId: number, newStatusName: string) => {
    setOrders(prev => ({
      ...prev,
      data: prev.data.map(order =>
        order.id === orderId
          ? { ...order, status_name: newStatusName }
          : order
      ),
    }));
  }, []);

  const updateOrder = useCallback((orderId: number, updates: Partial<Order>) => {
    setOrders(prev => ({
      ...prev,
      data: prev.data.map(order =>
        order.id === orderId
          ? { ...order, ...updates }
          : order
      ),
    }));
  }, []);

  const removeOrder = useCallback((orderId: number) => {
    setOrders(prev => ({
      ...prev,
      data: prev.data.filter(order => order.id !== orderId),
      total: prev.total - 1,
    }));
  }, []);

  return { orders, loading, setLoading, updateOrderStatus, updateOrder, removeOrder };
}
